var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExpensesIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4824 5H10.2697",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.23438 1C3.02524 1 1.23437 2.79087 1.23437 5L1.23438 13.8C1.23438 14.6487 1.61052 15.4626 2.27997 16.0627C2.94943 16.6628 3.85734 17 4.80409 17H13.7284C14.6751 17 15.5831 16.6628 16.2525 16.0627C16.922 15.4626 17.2981 14.6487 17.2981 13.8V4.2C17.2981 3.35128 16.922 2.53736 16.2525 1.93728C15.5831 1.33712 14.6751 1 13.7284 1H5.23438Z",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.23438 6H3.94116C4.58022 6 5.19306 6.26543 5.64494 6.73795C6.09682 7.21048 6.35072 7.8514 6.35072 8.5197C6.35072 9.18791 6.09682 9.82883 5.64494 10.3014C5.19306 10.7739 4.58022 11.0394 3.94116 11.0394H1.23438",
    stroke: "#353C47",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpensesIcon);
export default __webpack_public_path__ + "static/media/expensesIcon.4f8e132dff5233eb794b7178726315b7.svg";
export { ForwardRef as ReactComponent };